export const APP_VERSION = "1.0.0";
export const ENABLE_REDUX_DEV_TOOLS = true;
export const APP_NAME = `${process.env.REACT_APP_NAME}`;
export const APP_API_KEY = `${process.env.REACT_APP_API_KEY}`;
export const APP_DOMAIN = `${process.env.REACT_APP_DOMAIN_URL}`;
export const APP_API_URL = `${process.env.REACT_APP_API_URL}`;
export const REACT_IMAGE_URL = "https://soundsoul.cugate.com";
export const GOOGLE_MAP_KEY = `${process.env.REACT_APP_GOOGLE_MAP_KEY}`;
export const SOCIAL_KEYS = {
  GOOGLE: {
    CLIENT_ID: `${process.env.REACT_APP_GOOGLE_CLIENT_ID}`,
  },
  TWITTER: {
    URL: "https://www.twitter.com/WonderRovie",
    LOCATION: "San Diego",
    APP_ID: "22631669",
    //Consumer Keys
    API_KEY: "rVAN94l27XaIkpha7NP51Gl26",
    API_KEY_SECRET: "ugZPGZeQYwIoPJvDWMka7NWFD2yZtzDid5S2R3kg2yk7bLPcVn",
    //Authentication Tokens
    BEARER_TOKEN:
      "AAAAAAAAAAAAAAAAAAAAAPVUWQEAAAAAp9FIZ1IMdhHdMD1MilKaWFEiZ1w%3DhZBHiIMFcCtipjvlrEj7UnfDIEWRWtgqEIWAu7qoEQgfwzkyaT",
    ACCESS_TOKEN: "1465531185203847179-r81EiahT76a9dgLWJZ8lUxYwxKV7Ki",
    //OAuth2.0
    CLIENT_ID: "Zmg1T1E1RDNTTldmODdqUHdCUDQ6MTpjaQ",
    CLIENT_SECRET: "h15YmXfN6EQGRLp3dhIyvYi_dd2rWbYERIVBifVVa4s6QXHFwn",
  },
  LINKEDIN: {
    LOCATION: "Florida",
    CLIENT_ID: "86jox640ww4bz1",
    CLIENT_SECRET: "FLsfYB9JfYznrsG9",
    REDIRECT_URL: "https://cugate.com",
    DEVELOPER_URL:
      "https://docs.microsoft.com/en-us/linkedin/shared/integrations/people/profile-api",
    DEVELOPER_URL1: "https://developer.linkedin.com/",
    DEVELOPER_URL2: "https://www.linkedin.com/developers/apps/new",
    DEVELOPER_URL3:
      "https://www.linkedin.com/developers/apps/134527126/settings",
  },
  FACEBOOK: {
    APP_ID: `${process.env.REACT_APP_FACEBOOK_APP_ID} `,//"3106874846267794", //"1996533887185869", //,
    DEVELOPER_URL: "https://developers.facebook.com/products/instagram/apis/",
    DEVELOPER_URL1:
      "https://developers.facebook.com/docs/instagram-basic-display-api/getting-started",
  },
  INSTAGRAM: {
    CLIENT_ID: "921201001964201",
    CLIENT_SECRET: "921201001964201",
  },
  REDDIT: {
    URL: "https://www.reddit.com/user/foxyheroic",
    LOCATION: "Florida",
    CLIENT_ID: "PwN4QRT_YfvzgX2Jk4hz2Q",
    CLIENT_SECRET: "Cl0QtQh5PxdTBVTb2D9VMPH-Sqy1oQ",
    SCRIPT: "9YiDCXrww0aUJfUZ26IUOA",
    DEVELOPER_URL: "https://www.reddit.com/dev/api",
    DEVELOPER_URL1: "https://www.reddit.com/wiki/api",
    DEVELOPER_URL2: "https://www.reddit.com/prefs/apps",
  },
  YOUTUBU: {
    ACCOUNT: "CugateCompany@Gmail.com",
    LOCAATION: "San Diego",
    API_KEY: "AIzaSyDAgCHbv840iRR0vyXHTp8IW5PjHW-jk70",
    DEVELOPER_URL: "https://developers.google.com/youtube/v3/getting-started",
    DEVELOPER_URL1: "https://console.cloud.google.com/apis/credentials",
  },
};
export const STATUS_CODE = {
  UNKNOWN_FAILURE: -1,
  AUTH: {
    SUCCESS_LOGIN: 20000,
    REQUIRED_EMAIL_VERIFICATION: -10000,
    WRONG_USERNAME_OR_PASSORD: -20000,
  }
};
export const PAYMENT_KEYS = {
  PAYPAL: {
    ACCOUNT: `${process.env.REACT_APP_PAYPAL_ACCOUNT}`,
    CLIENT_ID: `${process.env.REACT_APP_PAYPAL_CLIENT_ID}`,
    SECRET: `${process.env.REACT_APP_PAYPAL_SECRET}`,
  }
};
export const COOKIE_PARAMS = {
  SELECTED: {
    LABEL: "kdpokhpythdmdlfigfgmkserwelrpfdgdsfgmdfgdnfgj",
    TRACK: "epgprdkthermsfiefgjosmrfeingsmlfdmsfiefsdvsfd",
  }
};
export const GLOBAL_URLS = {
  RELEASE_DETAIL_URL: 'https://www.cumarket.net/album/',
  RELEASE_EDIT_URL: '/release/edit?id=',
  RELEASE_DUPLICATE_URL: '/release/duplicate?duplicateId=',
  TRACK_RANK_URL: 'https://curadio.net/songrank.action',
  MEMBER_DETAIL_URL: 'https://www.cumarket.net/artist/',
}